<template>
    <div class="page">
        <div class="menu-wrap">
            <a href="https://www.mobitel.lk/games-apps#ChallengeME"><div class="menu-item" ></div></a>
            <div class="menu-item" @click="goto('qa')"></div>
            <div class="menu-item" @click="goto('info')"></div>
            <div class="menu-item" @click="unsub"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Setting',
    data(){
        return {
            id: '',
            name: '',
            mobile: '',
            score: 0,
            ranking: 0,
            list: [],

            showSharePop: false,
            shareTitle: '',
            shareDesc: '',
            questionId: this.$route.query.id
        }
    },
    computed: {
        ...mapState(['userInfo','lang','langMap'])
    },
    created(){

    },
    methods: {
        goto(page){
            this.$router.push(page);
        },
        unsub(){
          //this.$parent.baseHomeUrl+
            let url = "https://mechallenge.asia/unreg?mobile=" ;
            let msg = 'Are you sure want to unsubscribe?';
            let msisdn = localStorage.localMisisdn;
            if(msisdn == undefined) return false;
            this.$dialog.confirm({
                message: msg,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(action=>{
                //alert(action);
                if(action === 'confirm'){
                    localStorage.clear();
                    window.location = url + msisdn;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .menu-wrap{
        display: flex;
        width: rem(728);
        height: rem(538);
        margin:rem(240) auto 0;
        background: url('~@/assets/menu-1.png') center center/contain no-repeat;
        justify-content: space-between;
        flex-wrap: wrap;
        .menu-item{
            width: rem(363);
            height: rem(228);
            margin-bottom: rem(70);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue